import { render, staticRenderFns } from "./CEditor.vue?vue&type=template&id=37e145bc"
import script from "./CEditor.vue?vue&type=script&lang=js"
export * from "./CEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports